import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { styled } from 'linaria/react';
const Wrapper = /*#__PURE__*/styled("div")({
  name: "Wrapper",
  class: "w1n0uzon"
});
const Title = /*#__PURE__*/styled("h2")({
  name: "Title",
  class: "t10jqhqo"
});
const Content = /*#__PURE__*/styled("div")({
  name: "Content",
  class: "c3uu092",
  vars: {
    "c3uu092-0": [({
      up
    }) => up ? '200px' : 'auto'],
    "c3uu092-1": [({
      up
    }) => up ? '197px' : 'auto']
  }
});
const ReadMore = /*#__PURE__*/styled("p")({
  name: "ReadMore",
  class: "r1nvlmmr"
});
const A = /*#__PURE__*/styled("a")({
  name: "A",
  class: "a17h5wdc"
});
const EXPAND_TEXT = 'Mở rộng';
const COLLAPSE_TEXT = 'Thu gọn';
function Description(props) {
  const [up, setUp] = useState(true);
  const {
    content
  } = props;
  return content ? <Wrapper>
      <Title>Việc Làm Tốt - Kênh tìm việc làm nhanh chóng, hiệu quả cao hàng đầu Việt Nam</Title>
      <Content up={up} dangerouslySetInnerHTML={{
      __html: content
    }} />
      {content.length > 500 && <ReadMore>
          {up ? <A onClick={() => setUp(false)}>
              {EXPAND_TEXT} <i id="arrowIcon" className="fa fa-angle-down" aria-hidden="true" />
            </A> : <A onClick={() => setUp(true)}>
              {COLLAPSE_TEXT} <i id="arrowIcon" className="fa fa-angle-up" aria-hidden="true" />
            </A>}
        </ReadMore>}
    </Wrapper> : null;
}
Description.propTypes = {
  content: PropTypes.string.isRequired
};
export default Description;

require("../../../.linaria-cache/src/components/Description/index.linaria.module.css");